import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { WwwDirectusService, Show } from 'www-cms';
import { catchError, map, of } from 'rxjs';
import { ShowsGroupedByLocationAndYear } from './ticketing-show/ticketing-show.types';

export const ticketingResolver: ResolveFn<any> = (route, state) => {
  function sortShowsByDate(shows: ShowsGroupedByLocationAndYear[]) {
    for (const location of shows) {
      for (const year of location.years) {
        year.shows.sort((a, b) => {
          if (a.startDate < b.startDate) {
            return -1;
          }
          if (a.startDate > b.startDate) {
            return 1;
          }
          return 0;
        });
      }
    }
    return shows;
  }

  function groupShowsByLocationAndYear(shows: Show[]) {
    return shows.reduce((acc, show) => {
      if (!show.location) {
        return acc;
      }
      const locationIndex = acc.findIndex(
        (group) => group.locationCode === show.location?.locationCode
      );
      const year = +show.startDate.slice(0, 4);
      if (locationIndex === -1) {
        acc.push({
          locationCode: show.location?.locationCode || '',
          years: [{ year, shows: [show] }],
        });
        return acc;
      }
      const yearIndex = acc[locationIndex].years.findIndex(
        (yearGroup) => yearGroup.year === year
      );
      if (yearIndex === -1) {
        acc[locationIndex].years.push({ year, shows: [show] });
        return acc;
      }
      acc[locationIndex].years[yearIndex].shows.push(show);
      return acc;
    }, [] as ShowsGroupedByLocationAndYear[]);
  }

  return inject(WwwDirectusService)
    .getAvailableShows()
    .pipe(
      map(groupShowsByLocationAndYear),
      map(sortShowsByDate),
      catchError(() => of(undefined))
    );
};
